"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireWildcard(require("@bit/gerenciatd.unifiedcomponents.button"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.tagging");

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.modal-c2-c-emp"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils.js");

require("./callMeBackSE.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const COMPONENT_NAME = 'CallMeBackSE';

class CallMeBackSE extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      destino: '',
      tipoTes: '',
      tes: ''
    };
  }

  componentWillMount() {
    const selectedOption = (0, _utils._ChooseSendOptions)(this.props.multipleOptions);
    this.setState({
      destino: selectedOption.destino,
      tipoTes: selectedOption.tipoTes,
      tes: selectedOption.tes
    });
  }

  render() {
    const {
      label,
      color,
      activateOutHour,
      segment,
      visible,
      className,
      buttonProps,
      taggingInfo,
      Modal,
      fixedProduct,
      fixedCampaign
    } = (0, _gerenciatdUtils.setUpPropsByDevice)(this.props);

    if (!taggingInfo.componentName) {
      taggingInfo.componentName = COMPONENT_NAME;
    }

    const ownCss = className ? ` ${className}` : '';
    /* COMPLETING TAGGINGINFO IF NEEDED */

    taggingInfo.componentContent = _gerenciatdUtils2.CALL_4_SELLING_CONTENT.C2C;
    taggingInfo.componentVariation = this.state.destino;

    const onClick = () => {
      const {
        tipoTes,
        destino,
        tes
      } = this.state;
      Modal.setModalProps({
        contentPosition: 'center--center',
        opacityLayoutColor: 'black05',
        inSceneEffect: 'fadeInRight',
        outSceneEffect: 'fadeOutRight',
        closeByClickingOutside: true
      });
      Modal.setContent( /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
        tipoTes: tipoTes,
        tes: tes,
        Modal: Modal,
        taggingInfo: taggingInfo,
        destino: destino,
        fixedCampaign: fixedCampaign,
        fixedProduct: fixedProduct
      }));
      Modal.show();
    };

    if (!(0, _utils._CMNTimeTableValid)() && activateOutHour || !visible) {
      return null;
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread({
      segment: segment,
      className: `callMeBackSE_button ${ownCss}`,
      onClick: onClick,
      color: color,
      label: label,
      taggingInfo: taggingInfo,
      size: {
        w: _gerenciatdUnifiedcomponents.BUTTON_WIDTH.FULL
      }
    }, buttonProps));
  }

}

CallMeBackSE.defaultProps = {
  activateCML: false,
  color: _utils.PHONE_COLORS.WHITE,
  className: '',
  taggingInfo: {},
  buttonProps: {},
  visible: true,
  activateOutHour: true,
  segment: _utils.SEGMENT.GP,
  multipleOptions: [{
    porcentaje: 12,
    destino: _utils.DESTINO.INSIDESALES,
    tes: 'SI',
    tipoTes: 'ME_C'
  }, {
    porcentaje: 88,
    destino: _utils.DESTINO.GEVICO,
    tes: 'SI',
    tipoTes: 'SVC_C'
  }]
};
CallMeBackSE.propTypes = {
  /**
   * {
   *  "info": "Activar activateCallMeLater (CML)",
   *  "kind": "playground",
   *  "beautifulName": "Call Me Later"
   * }
   */
  activateCML: _propTypes.default.bool,

  /**
   * {
   *  "info": "Color del enlace del teléfono o del botón",
   *  "kind": "both",
   *  "beautifulName": "Color teléfono"
   * }
   */
  color: _propTypes.default.string,

  /**
   * {
   *  "info": "Segmento para definir carta de colores correspondiente",
   *  "kind": "both",
   *  "beautifulName": "segment"
   * }
   */
  segment: _propTypes.default.oneOf([_utils.SEGMENT.GP, _utils.SEGMENT.EMP]),

  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: _propTypes.default.object,

  /**
   * {
   *  "info": "Definición de las propiedades para el botón",
   *  "kind": "both",
   *  "beautifulName": "Propiedades botón"
   * }
   */
  buttonProps: _propTypes.default.object,

  /**
   * {
   *  "info": "Visibiliza el componente",
   *  "kind": "both",
   *  "beautifulName": "Visible"
   * }
   */
  visible: _propTypes.default.bool,

  /**
   * {
   *  "info": "Activa el fuera de horario",
   *  "kind": "both",
   *  "beautifulName": "ActivateOutHour"
   * }
   */
  activateOutHour: _propTypes.default.bool,

  /**
   * {
   *  "info": "Array que contiene la configuracion de porcentajes",
   *  "kind": "both",
   *  "beautifulName": "multipleOptions"
   * }
   */
  multipleOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    porcentaje: _propTypes.default.number.isRequired,
    destino: _propTypes.default.oneOf(_utils.DESTINO).isRequired,
    tes: _propTypes.default.oneOf(_utils.TESVALUES).isRequired,
    tipo: _propTypes.default.oneOf(_utils.TIPOS_ENCAMINAMIENTO).isRequired
  })).isRequired,
  Modal: _propTypes.default.func.isRequired,
  // Para cambiarle el producto que enviara el formulario
  fixedProduct: _propTypes.default.string,
  // Para setearle una campaña al formulario distinta de la que pueda dar SCX
  fixedCampaign: _propTypes.default.string
};
var _default = CallMeBackSE;
exports.default = _default;

//# sourceMappingURL=index.js.map